/**
 * @module builder
 */
import type { QuoteDocument, QuoteJobAddress } from 'paintscout'

export function setJobAddress(args: {
  quote: QuoteDocument
  jobAddress: QuoteJobAddress
  addressType?: 'billingAddress' | 'shippingAddress'
}): QuoteDocument {
  const { quote, jobAddress, addressType } = args
  if (addressType) {
    return {
      ...quote,
      [addressType]: jobAddress
    }
  } else {
    return {
      ...quote,
      jobAddress
    }
  }
}
